import { render, staticRenderFns } from "./StatisticEmployeesV2.vue?vue&type=template&id=546d2a73&"
import script from "./StatisticEmployeesV2.vue?vue&type=script&lang=ts&"
export * from "./StatisticEmployeesV2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports